import type { DynamicClient } from '@dynamic-labs-sdk/client';
import { getCore } from '@dynamic-labs-sdk/client/core';

import type {
  PhantomBroadcastMessage,
  PhantomEvents,
} from '../../phantomRedirect.broadcast.types';

/**
 * Broadcasts a Phantom redirect event to other tabs via the crossTabBroadcast
 * service.
 *
 * Used by the redirect-completion tab to notify the originating tab that
 * an operation has finished, since onceEvent listeners are in-memory and
 * do not cross tab boundaries.
 *
 * @param params.event - The DynamicEvents event name to broadcast
 * @param params.args - The event arguments to include in the message
 * @param client - The Dynamic client instance
 */
export const broadcastPhantomEvent = <K extends keyof PhantomEvents>(
  { args, event }: PhantomBroadcastMessage<K>,
  client: DynamicClient
): void => {
  getCore(client).crossTabBroadcast.send({ args, event });
};
